import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRushAverage = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 1C4.89543 1 4 1.89543 4 3C4 4.10457 4.89543 5 6 5C7.10457 5 8 4.10457 8 3C8 1.89543 7.10457 1 6 1ZM5 3C5 3.55228 5.44772 4 6 4C6.55228 4 7 3.55228 7 3C7 2.44772 6.55228 2 6 2C5.44772 2 5 2.44772 5 3Z'
    />
    <path d='M4.5 15C4.22386 15 4 14.7761 4 14.5V11H5V14.5C5 14.7761 4.77614 15 4.5 15Z' />
    <path d='M7.5 15C7.77614 15 8 14.7761 8 14.5V11H7V14.5C7 14.7761 7.22386 15 7.5 15Z' />
    <path d='M11.5 15C11.7761 15 12 14.7761 12 14.5V11H11V14.5C11 14.7761 11.2239 15 11.5 15Z' />
    <path d='M5.5 7C4.67157 7 4 7.67157 4 8.5V10.5C4 10.7761 3.77614 11 3.5 11C3.22386 11 3 10.7761 3 10.5V8.5C3 7.11929 4.11929 6 5.5 6H6.5C7.88071 6 9 7.11929 9 8.5V10.5C9 10.7761 8.77614 11 8.5 11C8.22386 11 8 10.7761 8 10.5V8.5C8 7.67157 7.32843 7 6.5 7H5.5Z' />
    <path d='M10 6.5C10 6.22386 10.2239 6 10.5 6C11.8807 6 13 7.11929 13 8.5V10.5C13 10.7761 12.7761 11 12.5 11C12.2239 11 12 10.7761 12 10.5V8.5C12 7.67157 11.3284 7 10.5 7C10.2239 7 10 6.77614 10 6.5Z' />
    <path d='M10 5C11.1046 5 12 4.10457 12 3C12 1.89543 11.1046 1 10 1V2C10.5523 2 11 2.44772 11 3C11 3.55228 10.5523 4 10 4V5Z' />
  </svg>
);
export default SvgRushAverage;
